/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useMemo, useState } from "react";
import { CSVLink } from "react-csv";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import moment from "moment-timezone";
import { Container } from "@material-ui/core";
import SingleSelectNew from "../../../../components/SelectField/SingleSelectNew";
import { getCompanyClients } from "../../../../services/apiservices/client";
import CircularProgress from "@mui/material/CircularProgress";
import * as Excel from 'exceljs';
import { downloadPDF, downloadExcel } from "../../DownloadReportUtils";
import { useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import AuthContext from "../../../../hooks/authContext";
import ActionRender from "../../ActionRender";
import { Label } from "../../../../components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../../components/ui/card";
import { Calendar, Download, FileSpreadsheet, FileText, Filter, Home, Mail, TrendingUp } from "lucide-react";
import { Button } from "../../../../components/ui/button";
import { getUpcomingClientTimesheetListReport } from "../../../../services/apiservices/timesheets";
import { getEmployeesListBasedOnId } from "../../../../services/apiservices/employee";
import { Popover, PopoverContent, PopoverTrigger } from "../../../../components/ui/popover";
import ThemeTable from "../../../../components/Table/ThemeTable";
import EmailReports from "../../EmailReports";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../../../components/ui/tooltip";
import { MobileRepeatVisitsNoShowsReport } from "../ClientMobileViewReports";
import { getSettings } from "../../../../services/apiservices/settings";
import { trackEvent, CMS_EVENTS } from "../../../../services/apiservices/analytics";

function RepeatVisitsNoShows(props) {
  const csvHeaders = [
    "Client",
    "Location",
    "Date",
    "Employees",
    "Type",
    "Count",
  ];
  const [clientsList, setClientList] = useState([]);
  const [clientsListMaster, setClientsListMaster] = useState([]);
  const [clientsListCSV, setClientListCSV] = useState([csvHeaders]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [clients, setClients] = useState();
  const [clientName, setClientName] = useState("All");
  const [type, setType] = useState("All");
  const [settingsData, setSettingsData] = useState();
  const [clientNameList, setClientNameList] = useState([
    { label: "All", value: "All" },
  ]);
  const isMobile = useMediaQuery('(max-width:767px)');
  const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
  const auth = useContext(AuthContext);
  const [loader, setLoader] = useState(false);
  const typeOptions = [
    { label: "Both", value: "All" },
    { label: "Repeat Visit", value: "Repeat" },
    { label: "No-Show", value: "No-Show" },
  ]
  const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const { setReportData } = auth || {};

  const getColumns = () => {
    const columns = [
      {
        id: "clientName",
        numeric: false,
        disablePadding: false,
        label: "Client",
        isSortable: false,
      },
      {
        id: "clientaddress",
        numeric: false,
        disablePadding: false,
        label: "Location",
        isSortable: false,
      },
      {
        id: "clientdate",
        numeric: false,
        disablePadding: false,
        label: "Date",
        isSortable: false,
      },
      {
        id: "employee",
        numeric: false,
        disablePadding: false,
        label: "Employees",
        isSortable: false,
      },
      {
        id: "type",
        numeric: false,
        disablePadding: false,
        label: "Type",
        isSortable: false,
      },
      {
        id: "count",
        numeric: false,
        disablePadding: false,
        label: "Count",
        isSortable: false,
      },

      {
        id: "Action",
        numeric: false,
        disablePadding: false,
        label: "Action",
        isSortable: false,
      },
    ];
    if (isMobile || isLandscape) {
      return columns.filter(col => col.id !== "clientName" && col.id !== "clientdate" && col.id !== "Action");
    }
    return columns;
  };

  useEffect(() => {
    trackEvent(CMS_EVENTS.REPORT_VIEWED, {
      user_id: auth?.userProfile?.id,
      report_name: "Repeat Visits & No-Shows Report",
    });
    const getClientsData = async () => {
      const [clientRes, settingsRes] = await Promise.all([
        new Promise((resolve) => getCompanyClients(companyId, resolve)),
        new Promise((resolve) =>
          getSettings("client_settings", companyId, (res) => resolve(res?.data))
        ),
      ]);
      const details = Array.isArray(clientRes?.data) ? clientRes?.data : [];
      const client = details?.map((item) => {
        return {
          value: item?.id,
          label: `${item?.firstName} ${item?.lastName}`,
        };
      })?.sort((a, b) => a?.label?.localeCompare(b?.label));
      const filteredData = settingsRes?.filter(
        (item) => !item.deleted
      );
      setSettingsData(filteredData?.length ? filteredData : []);
      setClients(details);
      setClientNameList([{ label: "All", value: "All" }, ...client]);
    };
    getClientsData();
  }, []);

  const handleclientNameChange = (e) => {
    const str = e;
    setClientName(str);
    if (str === "All") {
      setClientList(clientsListMaster);
    } else {
      setClientList(() =>
        clientsListMaster?.filter((itme) => {
          let returnFlg = true;
          if (str !== "All" && returnFlg) {
            returnFlg = itme?.clientNameId === str;
          }
          return returnFlg;
        })
      );
    }
  };

  const handletypeChange = (e) => {
    const str = e;
    setType(str);
    if (str === "All") {
      setClientList(clientsListMaster);
    } else {
      setClientList(() =>
        clientsListMaster?.filter((itme) => {
          let returnFlg = true;
          if (str !== "All" && returnFlg) {
            returnFlg = itme?.type === str;
          }
          return returnFlg;
        })
      );
    }
  };

  const getDatatoDownload = (rcellItem) => {
    let clientCSV = [];
    if (!Array.isArray(rcellItem)) {
      clientCSV = clientsList?.filter(
        (item) => item.clientNameId === rcellItem.clientNameId
      );
      clientCSV = clientCSV?.map((item) => {
        return [
          item?.clientName,
          item?.clientaddress,
          item?.clientdate,
          item?.employee,
          item?.type,
          item?.count,
        ];
      });
    } else {
      clientCSV = rcellItem?.map((item) => {
        return [
          item?.clientName,
          item?.clientaddress,
          item?.clientdate,
          item?.employee,
          item?.type,
          item?.count,
        ];
      });
    }
    return clientCSV;
  };

  const getDatatoFullDownload = (rcellItem) => {
    if (rcellItem) {
      clientsList?.filter(
        (item) => item.clientNameId === rcellItem.clientNameId
      );
      return [
        rcellItem?.clientName,
        rcellItem?.clientaddress,
        rcellItem?.clientdate,
        rcellItem?.employee,
        rcellItem?.type,
        rcellItem?.count,
      ];
    } else {
      return [
        rcellItem?.clientName,
        rcellItem?.clientaddress,
        rcellItem?.clientdate,
        rcellItem?.employee,
        rcellItem?.type,
        rcellItem?.count,
      ];
    }
  };

  const downloadForExcel = async (rcellItem, emailSend) => {
    const rcellItems = rcellItem?.records ? rcellItem?.records : rcellItem;
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet('Repeat Visits & No-Shows Report');

    const clientCSV = getDatatoDownload(rcellItems);
    let fileName;
    if (Array.isArray(rcellItems)) {
      fileName = `RepeatVisitsNoShowsReport_${rcellItems[0]?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    } else {
      fileName = `RepeatVisitsNoShowsReport_${rcellItems?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    }
    return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend)
  }

  const downloadForPDF = async (rcellItem, emailSend) => {
    const rcellItems = rcellItem?.records ? rcellItem?.records : rcellItem;
    const clientCSV = getDatatoDownload(rcellItems);
    let fileName;
    if (Array.isArray(rcellItems)) {
      fileName = `RepeatVisitsNoShowsReport_${rcellItems[0]?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    } else {
      fileName = `RepeatVisitsNoShowsReport_${rcellItems?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    }
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend);
  }

  const setDownloadCSVData = (event, done, rcellItem) => {
    const rcellItems = rcellItem?.records ? rcellItem?.records : rcellItem;
    const clientCSV = getDatatoDownload(rcellItems);

    const reportName = "Repeat Visits & No-Shows Report";
    const clientName = Array.isArray(rcellItems) ? `${rcellItems[0]?.clientName}` : `${rcellItems?.clientName}`;
    const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`;
    // Create the report details rows
    const reportDetails = [
      [`Client Name: ${clientName}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV
    ];

    // Set the CSV data
    setClientListCSV(reportDetails);
    done();
  };

  const setDownloadFullCSVData = (event, done) => {
    const clientCSV = clientsList?.map((item) => getDatatoFullDownload(item));
    let clientNamefordwonLoad = "All";

    if (clientName !== "All") {
      clientNamefordwonLoad = clientNameList?.filter(
        (item) => item.value === clientName
      )[0]?.label;
    }

    const reportName = "Repeat Visits & No-Shows Report";
    const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(
      endDate
    ).format("YYYY-MM-DD")}`;

    const reportDetails = [
      [`Employee Name: ${clientNamefordwonLoad}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV,
    ];

    setClientListCSV(reportDetails);
    done();
  };


  const downloadForFullPDF = async (emailSend) => {
    const clientCSV = clientsList.map((item) => getDatatoFullDownload(item));
    let clientNamefordwonLoad = 'All'

    if (clientName !== 'All') {
      clientNamefordwonLoad = clientNameList.filter((item) => item.value === clientName)[0].label
    }
    let fileName = `RepeatVisitsNoShowsReport_${clientNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend);
  }

  const downloadForFullExcel = async (emailSend) => {
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet('Repeat Visits & No-Shows Report');
    let clientNamefordwonLoad = 'All'

    const clientCSV = clientsList.map((item) => getDatatoFullDownload(item));

    if (clientName !== 'All') {
      clientNamefordwonLoad = clientNameList.filter((item) => item.value === clientName)[0].label
    }
    let fileName = `RepeatVisitsNoShowsReport_${clientNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
    return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend)
  }

  const handleEmailIconClick = async (rcellItem) => {
    const emailSend = true;
    let name;
    if (Array.isArray(rcellItem)) {
      name = rcellItem[0]?.clientName;
    } else {
      name = rcellItem?.clientName;
    }

    const [excelBlob, pdfBlob] = await Promise.all([
      downloadForExcel(rcellItem, emailSend),
      downloadForPDF(rcellItem, emailSend)
    ]);

    // Convert the Excel blob to a base64-encoded string
    const reader = new FileReader();
    reader.readAsDataURL(excelBlob);
    reader.onloadend = function () {
      const base64Data = reader.result;
      setReportData((prev) => ({
        ...prev,
        FileName: "RepeatVisitsNoShowsReport",
        ReportsName: "Client Report",
        Name: name,
        Date: startDate,
        EndDate: endDate,
        pdf: pdfBlob,
        storedData: base64Data,
        fullData: "",
        fullExcelData: ""
      }));
      setOpenEmailDialog(true);
    };
  };

  const handelEmailFullReport = async () => {
    const emailSend = true;

    let clientNamefordwonLoad = 'All'

    if (clientName !== 'All') {
      clientNamefordwonLoad = clientNameList?.filter((item) => item.value === clientName)[0]?.label
    }

    const [fullReport, fullExcelReport] = await Promise.all([
      downloadForFullPDF(emailSend),
      downloadForFullExcel(emailSend)
    ]);
    const reader = new FileReader();
    reader.readAsDataURL(fullExcelReport);
    reader.onloadend = function () {
      const base64Data = reader.result;
      setReportData((prev) => ({
        ...prev,
        FileName: "RepeatVisitsNoShowsReport",
        ReportsName: "Client Report",
        Name: clientNamefordwonLoad,
        Date: startDate,
        EndDate: endDate,
        fullData: fullReport,
        fullExcelData: base64Data,
        pdf: "",
        storedData: ""
      }));
      setOpenEmailDialog(true);
    }
  }

  const handleGenerateReport = async () => {
    setLoader(true);
    let paramStartDate = "";
    let paramEndDate = "";

    paramStartDate = startDate;
    paramEndDate = endDate;
    getReportListData(paramStartDate, paramEndDate);
  }
  const mapWithClientIds = async (employeeIds, timeSheet) => {
    getEmployeesListBasedOnId(employeeIds, (employeesList) => {
      const groupedByClient = {};
      timeSheet?.forEach((record) => {
        if (!groupedByClient[record?.clientId]) {
          groupedByClient[record?.clientId] = [];
        }
        groupedByClient[record?.clientId]?.push(record);
      });

      const finalData = [];

      Object.entries(groupedByClient)?.forEach(([clientId, records]) => {
        const clientInfo = clients?.find((c) => c?.id === clientId);
        const clientName = clientInfo?.clientName || "UnKnown";

        const clientaddress = [clientInfo?.addressInfo?.address, clientInfo?.addressInfo?.city, clientInfo?.addressInfo?.state, clientInfo?.addressInfo?.zip].filter(Boolean).join(", ");
        const clientdate = `${moment(startDate).format("MMM YYYY")} - ${moment(endDate).format("MMM YYYY")}`;

        const clientNameId = clientInfo?.id || "UnKnown";
        const repeatdata = records?.filter((item) => item?.checkInDateTime);
        const noshowdata = records?.filter((item) => !item?.checkInDateTime);
        const summarizeData = (recordsSubset, type) => {
          let cancelledCount = 0;
          let rescheduledCount = 0;
          const uniqueUserIds = new Set();
          const times = [];

          recordsSubset?.forEach((rec) => {
            const details = rec?.apoointmentDetails || {};

            if (details?.status === "Cancelled") cancelledCount++;
            if (details?.historyDate) rescheduledCount++;

            if (rec?.userId) uniqueUserIds.add(rec?.userId);
            if (rec?.checkInDateTime) {
              times.push(moment(rec?.checkInDateTime).format("DD MMM YYYY, hh:mm A"));
            } else {
              times.push("No Check-In");
            }
          });

          const employeeNames = Array.from(uniqueUserIds)
            ?.map((uid) => {
              const emp = employeesList?.find((e) => e.id === uid);
              return emp ? `${emp.firstName} ${emp.lastName}` : "";
            })
            .filter(Boolean);

          return {
            clientId,
            clientNameId,
            clientName,
            clientaddress,
            clientdate,
            type: type,
            count: recordsSubset?.length,
            times,
            totalAppointments: recordsSubset?.length,
            employee: employeeNames?.length,
            uniqueEmployeeCount: uniqueUserIds.size,
            employeeNames,
          };
        };

        if (repeatdata?.length) {
          finalData?.push(summarizeData(repeatdata, "Repeat"));
        }
        if (noshowdata?.length) {
          finalData?.push(summarizeData(noshowdata, "No-Show"));
        }
      });

      const sortedData = sortingFunction(finalData);
      setClientsListMaster(sortedData);
      setClientList(sortedData);
      setLoader(false);
    });
  };


  const sortingFunction = (data) => {
    const result = data.sort((a, b) => {
      if (a.clientName < b.clientName) return -1;
      if (a.clientName > b.clientName) return 1;
      // If clientName is the same, sort by clientdate
      if (a.clientdateTime < b.clientdateTime) return -1;
      if (a.clientdateTime > b.clientdateTime) return 1;
      return 0;
    });

    return result;
  };

  const getReportListData = async (startDt, endDt) => {
    const param = {
      startDate: `${dayjs(startDt).format("YYYY-MM-DD")}T00:00:00`,
      endDate: `${dayjs(endDt).format("YYYY-MM-DD")}T23:59:59`
    };

    getUpcomingClientTimesheetListReport(
      param,
      clientName,
      companyId,
      (result) => {
        const data = result;
        const employeeIds = [];
        for (let i = 0; i < data?.length; i++) {
          if (employeeIds?.indexOf(data?.[i].userId) === -1) {
            employeeIds?.push(data?.[i].userId);
          }
        }

        mapWithClientIds(employeeIds, data);
      },
      (err) => {
        console.log("err>>", err);
      }
    );
  };


  const getStatusBadgeColor = (type) => {
    switch (type) {
      case "Repeat":
        return "bg-blue-100 text-blue-600";
      case "No-Show":
        return "bg-red-100 text-red-600";
      default:
        return "bg-gray-100 text-gray-600";
    }
  };


  const renderRowCell = (rcellItem, hcellItem, index, rowindex,) => {
    switch (hcellItem.id) {
      case "clientName":
        if (
          rowindex !== 0 &&
          clientsList[rowindex - 1].clientName !== rcellItem.clientName
        ) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else if (rowindex === 0) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else {
          return "";
        }
      case "time":
        return <div className={`text-blue-600`}>{rcellItem?.time}</div>;
      case "endtime":
        return <div className={`text-blue-600`}>{rcellItem?.endtime}</div>;
      case "clientaddress":
        return (
          <Tooltip>
            <TooltipTrigger asChild>
              <Button variant="ghost" size="sm" className="h-6 w-6 p-0">
                {rcellItem?.clientaddress?.length > 20 ? rcellItem?.clientaddress?.slice(0, 20) + '...' : rcellItem?.clientaddress}
              </Button>
            </TooltipTrigger>
            <TooltipContent className="max-w-xs">
              <p className="text-sm">{rcellItem?.clientaddress}</p>
            </TooltipContent>
          </Tooltip>
        );
      case "employee":
        return (
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="text-sm font-medium cursor-pointer hover:text-primary transition-colors">
                {rcellItem?.employeeNames?.length}
              </div>
            </TooltipTrigger>
            <TooltipContent className="bg-white dark:bg-gray-800 border shadow-lg p-12 max-w-xs">
              <div className="space-y-1">
                {rcellItem?.employeeNames?.map((member, index) => (
                  <div key={index} className="text-sm">
                    {member}
                  </div>
                ))}
              </div>
            </TooltipContent>
          </Tooltip>
        );
      case "type":
        return (
          <div
            className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusBadgeColor(
              rcellItem?.type
            )}`}
          >
            {rcellItem?.type}
          </div>
        );
      case "Action":
        if (isMobile || isLandscape) {
          if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"RepeatVisitsNoShowsReport"}
              />
            );
          } else {
            return null;
          }
        } else {
          if (
            rowindex !== 0 &&
            clientsList[rowindex - 1].clientName !== rcellItem.clientName
          ) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"RepeatVisitsNoShowsReport"}
              />
            );
          } else if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"RepeatVisitsNoShowsReport"}
              />
            );
          } else {
            return "";
          }
        }
      default:
        return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
    }
  };

  const MobileViewData = useMemo(() => {
    if (!clientsList?.length) return [];

    return clientsList?.reduce((acc, item) => {
      const clientName = item?.clientName;

      const record = {
        id: item?.clientNameId,
        date: item?.clientdate,
        clientNameId: item?.clientNameId,
        clientaddress: item?.clientaddress,
        clientdate: item?.clientdate,
        count: item?.count,
        clientName: item?.clientName,
        employee: item?.employee,
        time: item?.time,
        location: item?.location,
        type: item?.type,
        employeeNames: item?.employeeNames,
      };

      const existingGroup = acc?.find((g) => g?.clientName === clientName);

      if (existingGroup) {
        existingGroup?.records?.push(record);
      } else {
        acc?.push({
          clientName,
          records: [record],
        });
      }

      return acc;
    }, []);
  }, [clientsList]);

  const filteredClient = clients?.find((item) => item?.id === clientName);
  const uniqueClientsMap = {};
  clientsList?.forEach(record => {
    uniqueClientsMap[record?.clientId] = record;
  });
  const uniqueClients = Object.values(uniqueClientsMap);
  let repeatCount = 0;
  let noShowCount = 0;

  clientsList?.forEach(client => {
    if (client?.type === "Repeat") repeatCount++;
    if (client?.type === "No-Show") noShowCount++;
  });

  const totalClients = uniqueClients?.length;
  const noShowRate = totalClients > 0 ? ((noShowCount / totalClients) * 100).toFixed(2) : 0;

  const handleEmailDialogClose = async () => {
    setOpenEmailDialog(false);
    await handleGenerateReport();
  };

  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Repeat Visits & No-Shows Report"
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Reports" },
            { label: "New Reports" },
            { label: "Client Reports", to: "/reports/newreport/clientreport" },
          ]}
          BreadCrumbCurrentPageTitle={"Repeat Visits & No-Shows Report"}
          showLastSeen={true}
        ></PageTitle>

        <div className={`sectionBox2 dark:bg-[#1A1F2C]`}>
          <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 max-w-7xl dark:bg-[#1A1F2C]">
            <div className="space-y-6">
              <Card className="shadow-sm dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] p-24">
                <CardHeader className="pb-12">
                  <div className="flex items-center space-x-2">
                    <Filter className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
                    <CardTitle className="text-lg sm:text-xl">
                      Report Parameters
                    </CardTitle>
                  </div>
                  <CardDescription className="text-left text-sm sm:text-base">
                    Configure the parameters for your cancellations & reschedules report
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
                    <div className="flex flex-col space-y-1">
                      <Label
                        htmlFor="client"
                        className="text-sm font-medium text-gray-700 dark:text-white"
                      >
                        Client Name *
                      </Label>
                      <SingleSelectNew
                        value={clientName}
                        name={"clientName"}
                        label={"Client Name"}
                        onChange={(e) => handleclientNameChange(e)}
                        options={clientNameList}
                        contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                        itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                        className="w-full min-h-[40px] px-3 py-2"
                      />
                    </div>

                    <div className="flex flex-col space-y-1">
                      <Label
                        htmlFor="startDate"
                        className="text-sm font-medium text-gray-700 dark:text-white"
                      >
                        Start Date *
                      </Label>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          value={startDate}
                          onChange={(newValue) => {
                            setStartDate(newValue);
                            // if (newValue) {
                            //   setEndDate(moment());
                            // } else {
                            //   setEndDate(null);
                            // }
                          }}
                          maxDate={moment()}
                          views={["year", "month", "day"]}
                          inputFormat="YYYY-MM-DD"
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              fullWidth: true,
                              className: "customDateInput",
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div>

                    <div className="flex flex-col space-y-1">
                      <Label
                        htmlFor="endDate"
                        className="text-sm font-medium text-gray-700 dark:text-white"
                      >
                        End Date *
                      </Label>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          value={endDate}
                          onChange={(newValue) => {
                            setEndDate(newValue);
                            // if (!newValue) {
                            //   setStartDate(null);
                            // }
                          }}
                          maxDate={moment()}
                          views={["year", "month", "day"]}
                          inputFormat="YYYY-MM-DD"
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              fullWidth: true,
                              className: "customDateInput",
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div>
                    <div className="flex flex-col space-y-1">
                      <Label
                        htmlFor="client"
                        className="text-sm font-medium text-gray-700 dark:text-white"
                      >
                        Type *
                      </Label>
                      <SingleSelectNew
                        value={type}
                        name={"type"}
                        label={"Type"}
                        onChange={(e) => handletypeChange(e)}
                        options={typeOptions}
                        contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                        itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                        className="w-full min-h-[40px] px-3 py-2"
                      />
                    </div>

                  </div>
                  <div className="flex justify-start sm:justify-end pt-8">
                    <Button
                      type="submit"
                      className="w-full sm:w-auto h-10 text-sm px-6"
                      onClick={() => handleGenerateReport()}
                    >
                      {loader ? (
                        <CircularProgress
                          size={28}
                          style={{ color: "white" }}
                        />
                      ) : (
                        <span className="d-flex flex-center">
                          <FileText className="w-4 h-4 mr-8" /> Generate Report
                        </span>
                      )}
                    </Button>
                  </div>
                </CardContent>
              </Card>
              {clientsList?.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  <Card>
                    <CardContent className="p-16">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm text-muted-foreground">Repeat Visits</p>
                          <p className="text-2xl font-bold text-blue-600 dark:text-blue-400">{repeatCount}</p>
                        </div>
                        <TrendingUp className="h-8 w-8 text-blue-600 dark:text-blue-400" />
                      </div>
                    </CardContent>
                  </Card>

                  <Card>
                    <CardContent className="p-16">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm text-muted-foreground">No-Shows</p>
                          <p className="text-2xl font-bold text-red-600 dark:text-red-400">{noShowCount}</p>
                        </div>
                        <Calendar className="h-8 w-8 text-red-600 dark:text-red-400" />
                      </div>
                    </CardContent>
                  </Card>

                  <Card>
                    <CardContent className="p-16">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm text-muted-foreground">Clients Affected</p>
                          <p className="text-2xl font-bold text-foreground">{uniqueClients?.length}</p>
                        </div>
                        <Home className="h-8 w-8 text-muted-foreground" />
                      </div>
                    </CardContent>
                  </Card>

                  <Card>
                    <CardContent className="p-16">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm text-muted-foreground">No-Show Rate</p>
                          <p className="text-2xl font-bold text-orange-600 dark:text-orange-400">{noShowRate}%</p>
                        </div>
                        <TrendingUp className="h-8 w-8 text-orange-600 dark:text-orange-400" />
                      </div>
                    </CardContent>
                  </Card>
                </div>
              )}

              {loader ? (
                <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                  <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                    Fetching report data...
                  </div>
                </Card>
              ) : clientsList?.length === 0 ? (
                <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                  <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                    No Records Found
                  </div>
                </Card>
              ) : (
                clientsList?.length > 0 && (
                  <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                    <CardHeader className="pb-16">
                      <div className="flex flex-col space-y-4 lg:flex-row lg:items-start lg:justify-between lg:space-y-0">
                        <div className="space-y-3 flex-1 min-w-0">
                          <CardTitle className="text-lg sm:text-xl d-flex flex-center">
                            <span>
                              <Calendar className="h-5 w-5 mr-3 text-blue-600 dark:text-blue-400" />
                            </span>
                            Repeat Visits & No-Shows Report
                          </CardTitle>
                          <CardDescription className="space-y-2">
                            <div className="font-medium text-sm sm:text-base">
                              {clientName === "All"
                                ? "All Client Report"
                                : `Client Report for ${filteredClient?.firstName} ${filteredClient?.lastName}`}
                            </div>
                            <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400"></div>
                          </CardDescription>
                        </div>
                        <div className="flex flex-wrap gap-2">
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => handelEmailFullReport()}
                            className="h-8"
                          >
                            <Mail className="mr-4 h-3 w-3" />
                            Email Report
                          </Button>
                          <Popover>
                            <PopoverTrigger asChild>
                              <Button
                                variant="outline"
                                size="sm"
                                className="h-8"
                              >
                                <Download className="mr-4 h-3 w-3" />
                                Download
                              </Button>
                            </PopoverTrigger>
                            <PopoverContent className="w-40">
                              <div className="space-y-2">
                                <Button
                                  variant="ghost"
                                  className="w-full justify-start h-8"
                                  onClick={() => downloadForFullPDF()}
                                >
                                  <FileText className="mr-8 h-3 w-3" />
                                  PDF
                                </Button>
                                <Button
                                  variant="ghost"
                                  className="w-full justify-start h-8"
                                  onClick={() => downloadForFullExcel()}
                                >
                                  <FileSpreadsheet className="mr-8 h-3 w-3" />
                                  Excel
                                </Button>
                                <CSVLink
                                  data={clientsListCSV}
                                  filename={`RepeatVisitsNoShowsReport_${clientName === "All"
                                      ? "All"
                                      : `${filteredClient?.firstName} ${filteredClient?.lastName}`
                                    }_${moment(startDate).format(
                                      "YYYY-MM-DD"
                                    )}_${moment(endDate).format(
                                      "YYYY-MM-DD"
                                    )}.csv`}
                                  asyncOnClick={true}
                                  onClick={(event, done) => {
                                    setDownloadFullCSVData(event, done);
                                  }}
                                  className="w-full flex justify-start items-center h-8 pv-8 ph-16 text-sm hover:bg-accent hover:text-accent-foreground rounded-md transition-colors"
                                >
                                  <FileSpreadsheet className="mr-16 h-4 w-4" />
                                  <span className="font-medium">CSV</span>
                                </CSVLink>
                              </div>
                            </PopoverContent>
                          </Popover>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent className="p-0 sm:p-6 sm:pt-0">
                      {!isMobile && (
                        <TooltipProvider>
                          <ThemeTable
                            rows={clientsList}
                            headCells={getColumns()}
                            hidePagination={true}
                            renderRowCell={renderRowCell}
                          />
                        </TooltipProvider>
                      )}
                      {isMobile && (
                        <MobileRepeatVisitsNoShowsReport
                          MobileViewData={MobileViewData}
                          handleEmailIconClick={handleEmailIconClick}
                          downloadForPDF={downloadForPDF}
                          downloadForExcel={downloadForExcel}
                          clientsListCSV={clientsListCSV}
                          setDownloadCSVData={setDownloadCSVData}
                          startDate={startDate}
                          endDate={endDate}
                          reportName={"RepeatVisitsNoShowsReport"}
                        />
                      )}
                    </CardContent>
                  </Card>
                )
              )}
            </div>
          </div>
        </div>
        <EmailReports
          open={openEmailDialog}
          onClose={() => handleEmailDialogClose()}
        />
      </Container>
    </>
  );
}

export default RepeatVisitsNoShows;